/**
 * External Imports
 */
import { FC, Dispatch, SetStateAction } from 'react';

/**
 * Style Imports
 */
import {
  NotesContainer,
  NotesHeader,
  NotesHeaderContainer,
  NotesContent,
  NoteIcon,
  IconsContainer
} from './NotesCard.styles';

interface NotesCardProps {
  id: string;
  date: string;
  noteId: string;
  author: string;
  message: string;
  deleteNote: Dispatch<SetStateAction<string>>;
}
const NotesCard: FC<NotesCardProps> = ({
  id,
  date,
  noteId,
  author,
  message,
  deleteNote
}) => {
  return (
    <NotesContainer id={id} className="p-2">
      <NotesHeaderContainer id={`Notes-Header-${noteId}`}>
        <NotesHeader className="my-0">{`${date} - ${author}`}</NotesHeader>
        <IconsContainer>
          <NoteIcon onClick={() => deleteNote(noteId)}>
            {' '}
            delete_outline{' '}
          </NoteIcon>
        </IconsContainer>
      </NotesHeaderContainer>
      <NotesContent
        id={`Notes-Content-${noteId}-${author}`}
      >{`${message}`}</NotesContent>
    </NotesContainer>
  );
};

// export default AddIssueFromPatientRound;
export default NotesCard;
